export default __webpack_public_path__ + "static/media/logoSIS.425d8ce0.png";